import {Component, ViewChild} from '@angular/core';
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService, ServiceBagServices} from "@base/component/ServiceBag";
import {ScreenService} from "@core/framework/screen.service";
import {BaseState} from "@base/entities/BaseEntities";
import {DemoMobilePhone, DemoMobilePhoneBrand, DemoMobilePhoneModel} from "@ui/demo/models/demo-mobile-phone";
import {EnumDemoMobilePhoneColor} from "@ui/demo/models/enum-demo-mobile-phone-color";
import {DxDataGridComponent} from "devextreme-angular";
import {GridExtender, GridCellEditParams} from "@base/grid/Grid.extender";
import {Utils} from "@core/helpers/Utils";

class State extends BaseState {
    Phones: DemoMobilePhone[] = [];
    Brands: DemoMobilePhoneBrand[] = [];
    Models: DemoMobilePhoneModel[] = [];
    Colors: any[] = [];

    SelectedPhones: DemoMobilePhone[] = [];
    
    TotalSum: number;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-demo-grids',
    templateUrl: './demo-grids.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoGridsComponent extends BaseComponent<State> {

    @ViewChild("gridExample") grid: DxDataGridComponent;
    public get G(): GridExtender { return (this.grid as any)?.G};
    
    constructor(A: ServiceBagService, public screen: ScreenService) {
        super(A, 'DemoGridsComponent', State);
    }

    protected override OnInitComponent() {
        this.InitData();
        this.State.Colors = this.GetColors();
    }

    protected override OnInitComponentFinished() {
        this.G.AttachColumnEditHandler(this, "Amount", { AfterEdit: 'OnAmountColumnChanged' });
        this.G.AttachColumnEditHandler(this, "Price", { AfterEdit: 'OnPriceColumnChanged' });
        this.G.AttachColumnEditHandler(this, "TotalSum", { AfterEdit: 'OnTotalSumColumnChanged' });
    }
    
    public OnSearchToolbarPreparing(event: any) {
        event.toolbarOptions.items.unshift({
            location: 'after',
            template: 'gridViewTemplate',
            isCustom: true
        });
    }

    public OnAmountColumnChanged(e: GridCellEditParams) {
        console.log(e);
        this.G.SetData(
            "TotalSum",
            Utils.ValEx(this.G.GetData('Amount', e)) * Utils.ValEx(this.G.GetData('Price', e)), 
            e);
    }
    
    public OnPriceColumnChanged(e: GridCellEditParams) {
        this.G.SetData(
            "TotalSum",
            Utils.ValEx(this.G.GetData('Price', e)) * Utils.ValEx(this.G.GetData('Amount', e)),
            e);
    }
    
    public OnTotalSumColumnChanged(e: GridCellEditParams) {
        this.G.SetData(
            "Price",
            Utils.ValEx(this.G.GetData('TotalSum', e)) / Utils.ValEx(this.G.GetData('Amount', e)),
            e);
    }
    
    public CalculateBrandDisplayName = (rowData) => {
        if (!rowData.BrandID)
            return;

        return this.State.Brands.find(x => x.EntryID === rowData.BrandID).Name;
    }

    public CalculateModelDisplayName = (rowData) => {
        if (!rowData.ModelID)
            return;

        return this.State.Models.find(x => x.EntryID === rowData.ModelID).Name;
    }

    public GetModelsToSelect(data) {        
        return this.State.Brands.find(x => x.EntryID === data.data.BrandID).Models;
    }

    public CalculateTotalSum() {
        this.State.TotalSum = this.State.Phones.map(i => i.TotalSum).reduce((a, b) => a + b);
    }
    
    public OnTrashClicked(event: any) {
        console.log(event);
    }
    
    private GetColors(): any[] {
        return [
            {
                Value: EnumDemoMobilePhoneColor.White,
                Text: 'White',
                SortOrder: 1,
            },
            {
                Value: EnumDemoMobilePhoneColor.Black,
                Text: 'Black',
                SortOrder: 2
            },
            {
                Value: EnumDemoMobilePhoneColor.AlpineGreen,
                Text: 'Alpine Green',
                SortOrder: 3
            },
            {
                Value: EnumDemoMobilePhoneColor.MidnightGray,
                Text: 'Midnight Gray',
                SortOrder: 4
            }
        ]
    }

    private InitData() {
        
        let s22Ultra = {
            EntryID: 1,
            Name: "S22 Ultra"
        } as DemoMobilePhoneModel;
        
        let s22 = {
            EntryID: 2,
            Name: "S22"
        } as DemoMobilePhoneModel;
        
        let fold = {
            EntryID: 3,
            Name: "Fold"
        } as DemoMobilePhoneModel;
        
        let samsungBrand = {
            EntryID: 1,
            Name: "Samsung",
            Models: [s22Ultra, s22, fold]
        } as DemoMobilePhoneBrand;

        let iPhone13 = {
            EntryID: 4,
            Name: "iPhone 13"
        } as DemoMobilePhoneModel;

        let iPhone12 = {
            EntryID: 5,
            Name: "iPhone 12"
        } as DemoMobilePhoneModel;
        
        let appleBrand =  {
            EntryID: 2,
            Name: "Apple",
            Models: [iPhone13, iPhone12]
        } as DemoMobilePhoneBrand;
        
        this.State.Brands = [samsungBrand, appleBrand];
        this.State.Models = [s22Ultra, s22, fold, iPhone12, iPhone13];
        
        this.State.Phones = [
            {
                ModelID: s22Ultra.EntryID,
                BrandID: samsungBrand.EntryID,
                Color: EnumDemoMobilePhoneColor.Black,
                IsAvailable: true,
                Amount: 3,
                Price: 1099,
                TotalSum: 3297
            },
            {
                ModelID: s22.EntryID,
                BrandID: samsungBrand.EntryID,
                Color: EnumDemoMobilePhoneColor.White,
                IsAvailable: false,
                Amount: 2,
                Price: 899,
                TotalSum: 1798
            },
            {
                ModelID: fold.EntryID,
                BrandID: samsungBrand.EntryID,
                Color: EnumDemoMobilePhoneColor.MidnightGray,
                IsAvailable: true,
                Amount: 5,
                Price: 1699,
                TotalSum: 8495
            },
            {
                ModelID: iPhone13.EntryID,
                BrandID: appleBrand.EntryID,
                Color: EnumDemoMobilePhoneColor.AlpineGreen,
                IsAvailable: true,
                Amount: 1,
                Price: 899,
                TotalSum: 899
            },
            {
                ModelID: iPhone12.EntryID,
                BrandID: appleBrand.EntryID,
                Color: EnumDemoMobilePhoneColor.White,
                IsAvailable: false,
                Amount: 0,
                Price: 799,
                TotalSum: 0
            }
        ];
        
        this.CalculateTotalSum();
    }
}
